import styled from "styled-components";

export const SelectSpacer = styled.div`
  & > div {
    padding-top: 4px;
  }
`;
